import { isLocalDevelop } from "utils/debug";
import Constant from "utils/isomorphismConstant";
import { OfferHasExpired, EndsIn, StartsOn, ErrorMessage, GoShopping, ViewMore } from "./texts";

const mutilLanTextMap: { [key: string]: any } = {
	"Starts On": StartsOn,
	"Ends In": EndsIn,
	"We‘re sorry，the offer has expired.": OfferHasExpired,
	error_message: ErrorMessage,
	go_shopping: GoShopping,
	"View More": ViewMore,
};

export function getLitbLangFn(
	keyValues: string,
	lang: string | undefined = Constant.language.toLowerCase(),
) {
	const langSource: any = mutilLanTextMap[keyValues] || {};
	const value: { [key: string]: string } = langSource[keyValues];
	if (!value) {
		return keyValues;
	}
	const lan = lang || "en";
	return value[lan] || value.en;
}
export function onChangeHeaderLang(lan: string) {
	let routerHref: string = location.href.slice(0);
	const originHref = routerHref;
	if (routerHref.match(/com(?!\/active)/gi)) {
		routerHref = routerHref.replace(/\/\w+\/active/, `/${lan}/active`);
	}
	if (routerHref.match(/\.me(?!\/ln)/gi)) {
		routerHref = routerHref.replace(/\/\w+\/ln/, `/${lan}/ln`);
	}
	if (isLocalDevelop() && routerHref.match(/8200(?!\/active)/)) {
		routerHref = routerHref.replace(/\/\w+\/active/g, `/${lan}/active`);
	}
	if (originHref === routerHref) {
		location.reload();
	} else {
		location.replace(routerHref);
	}
}
